import { ourPlansData } from "../../data/data";
import styles from "./home.module.css";
import { motion } from "framer-motion";
import { useState } from "react";

const OurPlans = () => {
  const [loadingId, setLoadingId] = useState(null);

  const handleWhatsAppClick = (id, title, offer, description, points) => {
    setLoadingId(id); // show loader on this button

    const phoneNumber = "919763440018";
    let message = `👋 Hello, I am interested in joining your training.\n`;
    message += `✨ Plan: ${title}\n`;
    message += `💰 Offer: ${offer}\n`;
    if (description) message += `🏷️ Description: ${description}\n`;
    message += `\nHere are the benefits I found:\n`;
    points.forEach((point) => {
      message += `• ${point}\n`;
    });
    message += `\nPlease share more details`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    // delay to show animation before opening WhatsApp
    setTimeout(() => {
      window.open(url, "_blank");
      setLoadingId(null); // reset loader
    }, 1000);
  };

  return (
    <div className={`${styles["our-plans"]} container sections-padding`}>
      <div>
        <p className="paragraph">Our Plans</p>
        <h2>Choose the Program</h2>
      </div>
      <div className={styles.plans}>
        {ourPlansData.map((ele) => (
          <div key={ele.id} className={styles.plan} data-aos="flip-up">
            <h3>
              <i className={ele.icon}></i> {ele.title}
            </h3>
            <div>
              <h4>{ele.offer}</h4>
              <p>{ele.description}</p>
            </div>
            <ul>
              {ele.points.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>

            <motion.button
              whileTap={{ scale: 0.85, rotate: -5 }}
              whileHover={{ scale: 1.05 }}
              onClick={() =>
                handleWhatsAppClick(
                  ele.id,
                  ele.title,
                  ele.offer,
                  ele.description,
                  ele.points
                )
              }
              className={styles.btn}
            >
              {loadingId === ele.id ? "⏳ Sending Msg..." : "Get Started"}
            </motion.button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurPlans;
